import FancyEdit from "./FancyEdit";

export default FancyEdit;